// extracted by mini-css-extract-plugin
export var component = "TableModule-module--component--XU6wP";
export var head = "TableModule-module--head--ptk7l";
export var table = "TableModule-module--table--FitvN";
export var td = "TableModule-module--td--5E1tM";
export var th = "TableModule-module--th--+yhyU";
export var title = "TableModule-module--title--ka-MT";